module.exports = __webpack_public_path__ + "static/media/Logo.40671b13.svg";